import { Formik } from "formik";
import React, { useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  Row,
  Label,
  ButtonGroup,
} from "reactstrap";
import searchIcon from "../../../assets/icon/search.svg";
import columnSelectorIcon from "../../../assets/icon/column-selector.svg";
import ReactStrapTable from "components/reactStrapTable";
import printIcon from "../../../assets/icon/print-icon.svg";
import printIconWhite from "../../../assets/icon/print-icon-white.svg";
import iconStatus from "../../../assets/icon/status-save-icon.svg";
import resetAllIcon from "../../../assets/icon/resetall.svg";
import applyIcon from "../../../assets/icon/apply.svg";
import { useNavigate } from "react-router-dom";
import VerticalStatusPopover from "components/VerticalStatusPopover";
import DescriptionShort from "components/DescriptionShort";
import MedicationShort from "components/MedicationShort";
import Checkbox from "components/common/Fields/Checkbox";
import SearchButtons from "components/SearchButtons";

const rowData = [
  {
    id: 1,
    // check: <Checkbox />,
    status: "Incomplete",
    dob: "19/4/12",
    due: "11:42 AM ",
    rx: "RX7203735",
    patient: "Young, Ethan ",
    medication: "Citalopram HBR Tablet 20MG ",
    label: "1/2 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 2,
    // check: <Checkbox />,
    status: "Incomplete",
    dob: "19/4/12",
    due: "11:43 PM  ",
    rx: "RX7203741 ",
    patient: "Lee, Emily",
    medication: "Loratadine Tablet 10MG  ",
    label: "1/2 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 3,
    // check: <Checkbox />,
    status: "Printed ",
    dob: "19/4/12",
    due: "11:45 AM  ",
    rx: "RX7203722 ",
    patient: "Walker, Benjamin ",
    medication: "Venlafaxine ER Tablet 150MG  ",
    label: "0/1  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 4,
    // check: <Checkbox />,
    status: "Printed ",
    dob: "19/4/12",
    due: "11:51 AM   ",
    rx: "RX7203723  ",
    patient: "King, Daniel  ",
    medication: "Metformin HCL Tablet 500MG   ",
    label: "0/1  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 5,
    // check: <Checkbox />,
    status: "Printed ",
    dob: "19/4/12",
    due: "11:57 AM  ",
    rx: "RX7203724 ",
    patient: "Adams, Harper  ",
    medication: "Levothyroxine Sodium Tablet 75MCG   ",
    label: "0/1  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 5,
    // check: <Checkbox />,
    status: "Printed ",
    dob: "19/4/12",
    due: "11:57 AM  ",
    rx: "RX7203725 ",
    patient: "Nguyen, Isabella  ",
    medication: "Gabapentin Capsule 300MG   ",
    label: "0/2 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 6,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:09 PM  ",
    rx: "RX7203726 ",
    patient: "Lee, Ethan   ",
    medication: "Sertraline HCL Tablet 100MG   ",
    label: "0/2  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 7,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:09 PM  ",
    rx: "RX7203726 ",
    patient: "Lee, Ethan   ",
    medication: "Sertraline HCL Tablet 100MG   ",
    label: "0/2  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 8,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:27 PM   ",
    rx: "RX7203729 ",
    patient: "Nguyen, Emma   ",
    medication: "Losartan Potassium Tablet 50MG   ",
    label: "0/2  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 9,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:33 PM   ",
    rx: "RX7203730 ",
    patient: "Baker, Ava  ",
    medication: "Hydrochlorothiazide Tablet 25MG ",
    label: "0/1  ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 10,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:39 PM   ",
    rx: "RX7203731 ",
    patient: "King, Isabella   ",
    medication: "Simvastatin Tablet 40MG  ",
    label: "0/1 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 11,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "12:57 PM  ",
    rx: "RX7203734   ",
    patient: "Patel, Mia  ",
    medication: "Fluoxetine HCL Capsule 20MG   ",
    label: "0/1 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 12,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:09 PM  ",
    rx: "RX7203736  ",
    patient: "Jackson, Sophia ",
    medication: "Clonazepam Tablet 0.5MG  ",
    label: "0/1 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },

  {
    id: 13,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:15 PM ",
    rx: "RX7203737  ",
    patient: "Taylor, Luna  ",
    medication: "Tramadol HCL Tablet 50MG   ",
    label: "0/2 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },

  {
    id: 14,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:21 PM  ",
    rx: "RX7203738   ",
    patient: "Jackson, Jacob  ",
    medication: "Trazodone HCL Tablet 100MG  ",
    label: "0/2 ",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 14,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:27 PM  ",
    rx: "RX7203739   ",
    patient: "Nelson, Olivia   ",
    medication: "Duloxetine DR Capsule 30MG  ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 14,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:33 PM ",
    rx: "RX7203740 ",
    patient: "Adams, Aarav    ",
    medication: "Bupropion HCL XL Tablet 150MG  ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 14,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:45 PM  ",
    rx: "RX7203742 ",
    patient: "Nelson, Lucas     ",
    medication: "Cetirizine HCL Tablet 10MG   ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 15,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:51 PM   ",
    rx: "RX7203743 ",
    patient: "Walker, Lucas    ",
    medication: "Prednisone Tablet 20MG   ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },

  {
    id: 16,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:57 PM ",
    rx: "RX7203744 ",
    patient: "King, Isabella    ",
    medication: "Propranolol HCL Tablet 40MG   ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 17,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "2:03 PM   ",
    rx: "RX7203745 ",
    patient: "Hill, Aarav     ",
    medication: "Topiramate Tablet 25MG  ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 18,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "1:51 PM   ",
    rx: "RX7203743 ",
    patient: "Walker, Lucas    ",
    medication: "Prednisone Tablet 20MG   ",
    label: "0/1",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 18,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "2:09 PM ",
    rx: "RX7203746  ",
    patient: "Harris, James  ",
    medication: "Lamotrigine Tablet 100MG  ",
    label: "0/2",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
  {
    id: 18,
    // check: <Checkbox />,
    status: "Not Printed ",
    dob: "19/4/12",
    due: "2:09 PM ",
    rx: "RX7203746  ",
    patient: "Harris, James  ",
    medication: "Lamotrigine Tablet 100MG  ",
    label: "0/2",
    entered: "12:23 PM",
    // img: <img src={iconStatus} />,
  },
];

const PackagingQueue = () => {
  const [columnOpen, setColumnOpen] = useState(false);
  const [tableData, setTableData] = useState(rowData);
  const [updateData, setUpdateData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [rSelected, setRSelected] = useState("off");

  const navigate = useNavigate();

  const handleRowClick = (row, e) => {
    if (e.target.value !== "checkbox") {
      navigate(`/workflow-packaging-info-Details/${row.id}`, { state: row });
    }
  };
  const [check, setCheck] = useState([
    {
      selectall: "",
      due: "",
      status: "",
      rx: "",
      patientName: "",
      medication: "",
      filltype: "",
      entered: "",
    },
  ]);
  const handleCheck = (e) => {
    const { name, checked } = e.target;
    if (name === "selectall") {
      setCheck({
        selectall: checked,
        due: checked,
        rx: checked,
        patientName: checked,
        medication: checked,
        filltype: checked,
        entered: checked,
        status: checked,
      });
    } else {
      setCheck((prevCheck) => {
        const updatedCheck = { ...prevCheck, [name]: checked };
        const allSelected = Object.values(updatedCheck).every(
          (val) => val === true
        );
        updatedCheck.selectall = allSelected;
        return updatedCheck;
      });
    }
  };
  const handleSelectAll = (e) => {
    if (e.target.checked) {
      setSelectedRows(rowData.map((row) => row.id));
    } else {
      setSelectedRows([]);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedRows.includes(id)) {
      setSelectedRows(selectedRows.filter((rowId) => rowId !== id));
    } else {
      setSelectedRows([...selectedRows, id]);
    }
  };
  const renderButtons = (rowData) => {
    return <VerticalStatusPopover row={rowData} />;
  };
  const RowCheckBox = (rowData) => {
    return (
      <div>
        {" "}
        <Input
          type="checkbox"
          onChange={() => handleSelectRow(rowData.id)}
          checked={selectedRows.includes(rowData.id)}
        />
      </div>
    );
  };
  const colHeader = [
    {
      dataField: "check",
      // width:120,
      text: (
        <div className="d-flex justify-content-flexstart align-items-center gap-2">
          <Input
            type="checkbox"
            onChange={handleSelectAll}
            checked={selectedRows.length === rowData.length}
          />
          All
        </div>
      ),
      cellRenderer: (rowData) => RowCheckBox(rowData),

      width: 50,
      show: true,
      disabled: true,
      hideColFilter: true,
      action: true,
      inputType: "checkbox",
    },
    {
      dataField: "status",
      text: "Order Status",
      show: true,
      sort: true,
      width: 60,
      cellRenderer: (rowData, col) => renderButtons(rowData),
    },
    {
      dataField: "due",
      text: "Due",
      show: true,
      sort: true,
      width: 60,
    },
    {
      dataField: "rx",
      text: "Rx Number",
      show: true,
      sort: true,
      width: 100,
    },
    {
      dataField: "patient",
      text: "Patient Name",
      show: true,
      sort: true,
      width: 100,
    },
    {
      dataField: "medication",
      text: "Medication",
      show: true,
      sort: true,
      width: 200,
      // cellRenderer: (rowData) => MedicationShort(rowData),
    },
    {
      dataField: "label",
      text: "Label",
      show: true,
      sort: true,
      width: 60,
    },
    {
      dataField: "entered",
      text: "Entered",
      show: true,
      sort: true,
      width: 60,
    },
  ];

  const filterColumns = () => {
    const columnIndexes = Object.entries(check)
      .filter(([key, value]) => value === true)
      .map(([key]) => {
        if (key === "status") return 1;
        if (key === "due") return 2;
        if (key === "rx") return 3;
        if (key === "patientName") return 4;
        if (key === "medication") return 5;
        if (key === "filltype") return 6;
        if (key === "entered") return 7;
        return -1;
      })
      .filter((index) => index !== -1);
    return colHeader.filter((_, index) => columnIndexes.includes(index));
  };
  const filteredColData = filterColumns();
  const totalCount = [
    check.due,
    check.status,
    check.rx,
    check.patientName,
    check.medication,
    check.filltype,
    check.entered,
  ].filter(Boolean).length;
  const handleSubmit = () => {
    setUpdateData(filteredColData.length > 0 ? filteredColData : colHeader);
    setColumnOpen(false);
  };
  const handleNavigate = () => {
    navigate("/packaging-info-details");
  };

  const toggleFilter = () => {
    setRSelected((prev) => (prev === "off" ? "on" : "off"));
  };

  const tableFilterData = tableData.length
    ? tableData.map((patient) => {
        return {
          id: patient.id,
          status: (
            <>
              <VerticalStatusPopover
                patientId={patient.id} // Example prop: Pass patient ID
                patientStatus={patient.status}
              />
            </>
          ),

          id: patient.id,
          status: patient.status,
          due: patient.due,
          rx: patient.rx,
          medication: patient.medication,
          patient: patient.patient,
          medication: patient.medication,
          label: patient.label,
          entered: patient.entered,
          //medication: user.username,
        };
      })
    : [
        {
          id: "",
          status: "",
          due: "",
          rx: "",
          medication: "",
          patient: "",
          medication: "",
          label: "",
          entered: "",
        },
      ];

  return (
    <div className=" table-card scroll-table position-relative layout-alignment border-0 rounded bg-white pb-0">
      <div className="heading-text section-devider-border pb-2 mb-1">
        Packaging Queue
      </div>
      <Row className="mt-2">
        <Col
          lg={6}
          md={6}
          className="d-flex justify-content-start"
          style={{ gap: "12px" }}
        >
          <SearchButtons
            InSize={300}
            placeHolder={"Search by Patient Name or Scan Rx"}
            data={tableData}
            row={rowData}
            setFilterData={setTableData}
          />
          <Dropdown
            isOpen={columnOpen}
            toggle={() => setColumnOpen(!columnOpen)}
          >
            <DropdownToggle className="clmn">
              <img src={columnSelectorIcon} alt="not available" />
              <span className="d-flex justify-content-center align-items-center gap-2">
                Columns{" "}
                {totalCount > 0 && (
                  <div className="totalcount">{totalCount}</div>
                )}
              </span>
            </DropdownToggle>
            <DropdownMenu className="drop-down-clm">
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="selectall"
                  value={check.selectall}
                  onChange={handleCheck}
                  checked={check.selectall}
                />
                <span className="m-2">Select All</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="status"
                  value={check.status}
                  onChange={handleCheck}
                  checked={check.status}
                />
                <span className="m-2">Status</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="due"
                  value={check.due}
                  onChange={handleCheck}
                  checked={check.due}
                />
                <span className="m-2">Due</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="patientName"
                  value={check.patientName}
                  onChange={handleCheck}
                  checked={check.patientName}
                />
                <span className="m-2">Patient Name</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="rx"
                  value={check.rx}
                  onChange={handleCheck}
                  checked={check.rx}
                />
                <span className="m-2">Rx Number</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="filltype"
                  value={check.filltype}
                  onChange={handleCheck}
                  checked={check.filltype}
                />
                <span className="m-2">Fill Type</span>
              </DropdownItem>
              <DropdownItem className="dropdownitem-border drp-down-clm-item">
                <Input
                  type="checkbox"
                  name="entered"
                  value={check.entered}
                  onChange={handleCheck}
                  checked={check.entered}
                />
                <span className="m-2">Entered</span>
              </DropdownItem>
              <div className="d-flex justify-content-center align-items-center p-2 drp-down-clm-item">
                <Button
                  onClick={() =>
                    setCheck({
                      selectall: false,
                      due: false,
                      medication: false,
                      rx: false,
                      patientName: false,
                      filltype: false,
                      entered: false,
                      status: false,
                    })
                  }
                >
                  {" "}
                  <img src={resetAllIcon} alt="" /> Reset All
                </Button>
                <Button
                  color="primary"
                  onChange={handleCheck}
                  onClick={handleSubmit}
                >
                  {" "}
                  <img src={applyIcon} alt="" /> Apply
                </Button>
              </div>
            </DropdownMenu>
          </Dropdown>
          <div className="d-flex justify-content-center align-items-center gap-2">
            <span className="f-16 font-weight-600">Filter</span>
            <ButtonGroup className="filter-btn-group">
              <Button
                color="info"
                outline
                onClick={toggleFilter}
                active={rSelected === "off"}
              >
                OFF
              </Button>
              <Button
                color="info"
                outline
                active={rSelected === "on"}
                onClick={toggleFilter}
              >
                ON
              </Button>
            </ButtonGroup>
          </div>
        </Col>
        <Col
          md={6}
          lg={6}
          className="d-flex justify-content-end"
          style={{ gap: "12px" }}
        >
          <div>
            <Button className="back-button">
              <img src={printIcon} />
              Batch Print
            </Button>
          </div>
          <div>
            <Button color="primary">
              <img src={printIconWhite} />
              Print
            </Button>
          </div>
        </Col>
      </Row>
      <div fixed-height={rowData.length > 0 ? "fixed-height" : "default"}>
        <ReactStrapTable
          id="packaging"
          data={tableFilterData}
          columns={updateData.length > 0 ? updateData : colHeader}
          enablerowRouting={true}
          handleRowClick={handleRowClick}
          redRow={[0, 1]}
        />
      </div>
    </div>
  );
};
export default PackagingQueue;
